






























import { Vue, Component, Prop } from "vue-property-decorator";
import { NotaAzienda } from "../../_models/notaAzienda";

@Component
export default class DetailsNotaAzienda extends Vue {
    @Prop() info!: NotaAzienda;
}
